import { ConnectedRouter as Router } from "connected-react-router";
import PropTypes from "prop-types";
import { useNavigtionCapture } from "./useNavigtionCapture";
import setupRouteChangeListener from "./setupRouteChangeListener";
import { useStore } from "react-redux";
import history from "../../client/history";

const ClientRouter = ({ children }) => {
  const store = useStore();

  setupRouteChangeListener(store);

  useNavigtionCapture(history);

  return <Router history={history}>{children}</Router>;
};

ClientRouter.propTypes = {
  children: PropTypes.node.isRequired,
  history: PropTypes.object.isRequired
};

export default ClientRouter;
